import { setPageConfig } from '../../app/actions'

export default function fetchComponentData(dispatch, renderProps = {}, location, actions = [], edition, appProps) {

  let { components = [], params = {} } = renderProps

  let loadActions = components.reduce( (prev, current) => {
    return (current && current.loadActions || [])
      .concat((current && current.WrappedComponent ? current.WrappedComponent.loadActions : []) || [])
      .concat(prev)
  }, (actions).concat(setPageConfig))

  loadActions = [ ...new Set(loadActions) ]

  const promises = loadActions.map(action => dispatch(action({ edition, params, location, appProps })))

  return Promise.all(promises)
}



// WEBPACK FOOTER //
// ./lib/fetchComponentData.js